import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

import { ELanguages } from "./ELanguages";
import { ETLCodes } from "./ETLCodes";
import fr from "./resources/fr.json";
import i18next from "i18next";
import { getBaseUrl } from "../baseUrl";

const resources = {
  fr,
};

(window as any).MISSING_TL_KEYS = {};
(window as any).GetMissingKeysEnum = () => {
  const s = Object.keys((window as any).MISSING_TL_KEYS).join(",\n");
  console.log("," + s);
  return s;
};

function extractLocale() {
  const drupalLanguage = localStorage.getItem("drupal-language")?.toLocaleLowerCase();
  const availableLanguages = ["fr", "nl", "en"];
  if (availableLanguages.includes(drupalLanguage)) {
    return drupalLanguage.toUpperCase();
  } else {
    return "FR";
  }
}

i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    lng: extractLocale(),
    fallbackLng: "FR",
    react: {
      useSuspense: true,
    },
    backend: {
      loadPath: `${getBaseUrl()}/api/translations/?languageCode={{lng}}`,
      addPath: `${getBaseUrl()}/api/translations/{{lng}}`,
      parse: (data: string) => {
        const parsed = JSON.parse(data);
        const reduced: object = parsed.reduce((prev, curr) => {
          prev[curr.translationCode] = curr.text;
          return prev;
        }, {});
        return reduced;
      },
      parsePayload: function (namespace, key, fallbackValue) {
        let value = fallbackValue;
        if (resources[i18next.language]) {
          const tls = resources[i18next.language]?.translation;
          if (tls && tls[key]) {
            value = tls[key];
          }
        }

        const data = {
          text: value,
          translationCode: key,
          currentLang: i18n.language,
        };
        return data;
      },
    },
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    parseMissingKeyHandler: (key) => {
      (window as any).MISSING_TL_KEYS[key] = true;
      return `${key}_MISSING_TL`;
    },
    saveMissing: true,
  });

export default i18n;

export const tlCodesArray = Object.keys(ETLCodes)
  .filter((k) => typeof ETLCodes[k as any] === "number")
  .sort();
export const languagesArray = Object.keys(ELanguages)
  .filter((k) => typeof ELanguages[k as any] === "number")
  .sort();

export { ELanguages, ETLCodes };
